<template>

    <form class="iwd-standard-form" method="post">
        <div class="iwd-form-row">
            <label for="card-number-element">Card number</label>
            <div class="iwd-input" id="card-number-element">
                <!-- insert Stripe card number field -->
            </div>
            <label class="error">{{ element_errors.card_number}}</label>
        </div>
        <div class="iwd-form-row">
            <label for="card-expiry-element">Card expiry</label>
            <div class="iwd-input" id="card-expiry-element">
                <!-- insert Stripe card number field -->
            </div>
            <label class="error">{{ element_errors.card_expiry}}</label>
        </div>
        <div class="iwd-form-row">
            <label for="card-cvc-element">Card CVC</label>
            <div class="iwd-input" id="card-cvc-element">
                <!-- insert Stripe card number field -->
            </div>
            <label class="error">{{ element_errors.card_cvc}}</label>
        </div>
        <div class="fxrsc mt100 mb150">
            <div class="iwd-input">
                <input type="checkbox" id="use-as-default" checked>
            </div>
            <label for="card-cvc-element" class="ml050">Use as default</label>
        </div>
        <div class="big-btns">
            <a class="black" href="#" id="checkout-confirm-payment-btn">Confirm &amp; continue</a>
        </div>
    </form>

    <p v-if="processing" class="mt100 mb100">Processing...</p>

<!--    <form class="checkout-navigation mt500" method="POST">-->
<!--        <p class="checkout-payment-error" v-if="response" v-html="response.message"></p>-->
<!--        <button type="submit" id="checkout-confirm-payment-btn">Confirm payment &amp; place order</button>-->
<!--    </form>-->

</template>

<script>

    export default {
    	data(){
            return {
            	processing: false,
                element_errors: {
                    card_number: '',
                    card_expiry: '',
                    card_cvc: ''
                },
                completed: {
                    card_number: false,
                    card_expiry: false,
                    card_cvc: false
                },
                response: null
            }
        },
        props: {
            'stripe_key': String,
            'client_secret': String
        },
        mounted(){
            this.stripe = Stripe(this.stripe_key);
            let elements = this.stripe.elements();

            const style = {
                base: {
                    iconColor: '#666EE8',
                    color: '#333',
                    fontWeight: '300',
                    fontFamily: '"Roboto Mono", sans-serif',
                    fontSize: '15px',
                    fontSmoothing: 'never',
                    '::placeholder': {
                        color: '#CCC',
                    }
                },
                invalid: {
                    color: 'red',
                    ':focus': {
                        color: '#333',
                    },
                }
            };

            // CARD NO.
            var cardNumberElement = elements.create('cardNumber', {
                style: style
            });
            cardNumberElement.mount('#card-number-element');
            cardNumberElement.on('change', (event)=>{
                this.completed.card_number = event.complete;
                this.element_errors.card_number = event.error?.message ?? '';
            });

            // CARD EXPIRY
            var cardExpiryElement = elements.create('cardExpiry', {
                style: style
            });
            cardExpiryElement.mount('#card-expiry-element');
            cardExpiryElement.on('change', (event)=>{
                this.completed.card_expiry = event.complete;
                this.element_errors.card_expiry = event.error?.message ?? '';
            });

            // CVC
            var cardCvcElement = elements.create('cardCvc', {
                style: style
            });
            cardCvcElement.mount('#card-cvc-element');
            cardCvcElement.on('change', (event)=>{
                this.completed.card_cvc = event.complete;
                this.element_errors.card_cvc = event.error?.message ?? '';
            });

            // console.log(this.client_secret);

            $('#checkout-confirm-payment-btn').on('click', async (e) => {

            	e.preventDefault();

            	this.processing = true;

                const { setupIntent, error } = await this.stripe.confirmCardSetup(
                    this.client_secret, {
                        payment_method: {
                            card: cardNumberElement,
                            billing_details: { name: 'Inigo Pascall' }
                        }
                    }
                );

                if (error) {
                    this.processing = false;
                } else {
                    this.postToUrl('/account/manage-subscription/add-card', {
                        'payment_method_identifier': setupIntent.payment_method,
                        'use_as_default': $('input#use-as-default').is(':checked')
                    });
                }
            });
        }
    }

</script>

<style scoped>

.StripeElement {
  /*height: 40px;*/
  /*padding: 10px 12px;*/
  padding: .75em;
    /*font-size: 9px;*/
  /*color: #333;*/
  /*background-color: white;*/
  border: 1px solid #DDDDDD;
  border-radius: 0;

  box-shadow: 0 0 0 0 #e6ebf1;


  background: #ffffff;
  color: #444444;
  -webkit-transition: all linear 0.2s;
  transition: all linear 0.2s;

}
input:focus,
.StripeElement--focus {
  box-shadow: 0 0 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

</style>
